import { useDisasterStore } from '../disasterStore'
import { useMiiaFwStore } from '@/stores/miiaFwStore'
import { useCommonModalStore } from '@/stores/commonModalStore'
import { useAdminDistrictsStore } from '../adminDistrictsStore'
import { useGovernmentSettingStore } from '../governmentSettingStore'
import { useInspectionResultStore } from '../inspectionResultUpsertStore'
import { useNetworkStore } from '../networkStore'
import { useHoldTemporaryStore } from '../holdTemporaryStore'
import { useInspectionResultQueryStore } from '../inspectionResultQueryStore'
import { useOfflineDataDownloadProcessStore } from '../offlineDataDownloadProcessStore'

export const useStoreUtils = () => {
  const commonModalStore = useCommonModalStore()
  const miiaFwStore = useMiiaFwStore()
  const disasterStore = useDisasterStore()
  const adminDistrictsStore = useAdminDistrictsStore()
  const governmentSettingStore = useGovernmentSettingStore()
  const inspectionResultStore = useInspectionResultStore()
  const inspectionResultQueryStore = useInspectionResultQueryStore()
  const networkStore = useNetworkStore()
  const holdTemporaryStore = useHoldTemporaryStore()
  const offlineDataDownloadProcessStore = useOfflineDataDownloadProcessStore()

  const allReset = () => {
    commonModalStore.reset()
    miiaFwStore.reset()
    disasterStore.reset()
    adminDistrictsStore.$reset()
    governmentSettingStore.$reset()
    inspectionResultStore.resetAll()
    inspectionResultQueryStore.$reset()
    networkStore.$reset()
    holdTemporaryStore.$reset()
    offlineDataDownloadProcessStore.$reset()
  }

  return {
    allReset
  }
}
